import { Component, Input, AfterViewInit } from '@angular/core';

import { AssessmentService } from '../../../services/assessment.service';
import { BannerService } from '../../../@core/services/banner.service';

declare var $: any;

@Component({
  selector: 'app-banner-show',
  templateUrl: './banner.component.html',
  styleUrls: ['../../userpanel.component.css'],
  providers: [AssessmentService, BannerService]
})
export class BannerComponent implements AfterViewInit {

  @Input() public banner: any;
  @Input() public isModal: any;
  @Input() public percentage: any;
  @Input() public trailId: any;

  constructor(
    private _bannerService: BannerService
  ) {
  }

  ngAfterViewInit() {
    this.showModal();
  }

  public checkIfNeedToShowBanner(): boolean {
    return (this.isModal === 0 && this.banner.data.length > 0);
  }

  public showModal(): void {

    if (this.checkIfNeedToShowBanner()) {
      if (this.percentage === 100) {
        this.sendFeedBack();
        this.openModal();
      }
    }
  }

  private sendFeedBack(): void {
    this._bannerService.trailView(this.trailId)
      .subscribe(res => {
        console.log(res);
      });
  }

  openModal() {
    $('#banner-modal-75').modal();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/listagem-cursos/banner/banner.component.ts